import React from 'react';
import { Link } from 'react-router-dom';
import image0 from '../images/image0.JPEG';

function Home() {
  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          {/* Featured Image */}
          <div style={{display: 'flex', justifyContent: 'center', margin: '0 0 2rem 0', paddingTop: '5rem'}}>
            <img
              src={image0}
              alt="NBA All-Star Weekend"
              style={{maxWidth: '400px', width: '100%', height: 'auto', borderRadius: '8px'}}
            />
          </div>

          {/* <p className="hero-subtitle">February 13-15, 2026</p> */}
          {/* <h1 className="hero-title">LA Function NBA All-Star Weekend Events</h1> */}
          <p className="hero-description" style={{textAlign: 'center'}}>
            <strong>LA Function NBA All-Star Weekend 2026 - Los Angeles</strong><br/>
            The Ultimate Celebration of Basketball, Music & Culture<br/><br/>

            Party with SupremeTeam LA, LA Function, 92.3 The Real, iHeart Media, Headliner Market Group and more at the hottest All-Star Weekend events in Los Angeles.<br/><br/>

            This is more than basketball — it's three unforgettable nights bringing together the biggest names in hip-hop, the most exclusive nightlife experiences, and a city-wide celebration unlike any other.<br/><br/>

            From the official kickoff party with 2 Chainz & G Herbo to the Valentine's Day Doo-Wop experience and the grand finale celebrating Rick Ross' birthday, every event is designed to give you the complete All-Star Weekend experience.<br/><br/>

            <strong>🎉 THREE LEGENDARY NIGHTS</strong><br/>
            <strong>Friday, Feb 13:</strong> All-Star Weekend Kickoff with 2 Chainz, G Herbo, Wallie the Sensei and Cactus Jack Records<br/>
            <strong>Saturday, Feb 14:</strong> Doo-Wop Love & Basketball Valentine's Edition<br/>
            <strong>Sunday, Feb 15:</strong> Rick Ross Birthday Celebration & Weekend Finale<br/><br/>

            <strong>✨ WHAT TO EXPECT</strong><br/>
            Celebrity appearances & industry crowd<br/>
            Top DJs & live performances<br/>
            Premium nightlife experiences<br/>
            VIP table service & bottle packages<br/>
            The ultimate All-Star Weekend send-off<br/><br/>

            This is your chance to be part of the biggest basketball weekend of the year.<br/>
            Tickets are selling fast — secure yours now before they're gone.
          </p>

          <div className="hero-cta">
            <Link to="/event1" className="btn btn-primary">Explore Events</Link>
            <a href="https://www.eventbrite.com/o/supreme-team-los-angeles-16817637124" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">Get Tickets</a>
          </div>
        </div>
      </section>

      {/* Events Grid */}
      {/* <section className="section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Weekend Events</h2>
            <p className="section-subtitle">
              Four incredible events making up an unforgettable weekend
            </p>
          </div>

          <div className="events-grid">
            <div className="event-card">
              <span className="event-number">01</span>
              <h3>event 1</h3>
              <p>
                The league's sharpest shooters battle it out from beyond the arc in this high-stakes shooting competition. Watch precision meet pressure as players have 60 seconds to sink as many threes as possible.
              </p>
              <Link to="/event1" className="event-link">
                Learn More →
              </Link>
            </div>

            <div className="event-card">
              <span className="event-number">02</span>
              <h3>event 2</h3>
              <p>
                Witness gravity-defying athleticism as the NBA's most explosive dunkers showcase creativity, power, and style. Each dunk is a masterpiece of aerial artistry that pushes the boundaries of what's possible.
              </p>
              <Link to="/event2" className="event-link">
                Learn More →
              </Link>
            </div>

            <div className="event-card">
              <span className="event-number">03</span>
              <h3>event 3</h3>
              <p>
                An obstacle course testing speed, ball-handling, passing accuracy, and shooting. Players race against the clock while demonstrating their complete skill set in this fan-favorite competition.
              </p>
              <Link to="/event3" className="event-link">
                Learn More →
              </Link>
            </div>

            <div className="event-card">
              <span className="event-number">04</span>
              <h3>event 4</h3>
              <p>
                The main event. The best players from both conferences compete in an exhibition showcase filled with incredible plays, highlight-reel moments, and unmatched star power on one court.
              </p>
              <Link to="/event4" className="event-link">
                Learn More →
              </Link>
            </div>
          </div>
        </div>
      </section> */}

      {/* Call to Action */}
      <section className="section" style={{background: 'var(--dark-gray)'}}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">All Events Will Sell Out!</h2>
            <p className="section-subtitle">
              Don't miss your chance to attend the best events all weekend long
            </p>
            <div style={{marginTop: '2rem'}}>
              <a href="https://www.eventbrite.com/o/supreme-team-los-angeles-16817637124" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Get Your Tickets Now</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
